/**
 * 인자로 받은 상품 id를 가진 상품을 장바구니에서 찾아 반환한다.
 * @param {*} state
 * @param {string} productId - 상품 id
 */
const findItemFromCart = (state, productId) =>
  state.items.find(item => item.productId === productId)

const SET_PRODUCT_LIST_OF_CART = (state, { cartList, purchaseCheckList }) => {
  state.items = [...[], ...cartList]
  state.purchaseCheckList = [...state.purchaseCheckList, ...purchaseCheckList]
}

/**
 * 장바구니에 새로운 상품을 추가한다.
 * @param {*} state
 * @param {Object} product - 추가할 상품
 */
const ADD_PRODUCT_TO_CART = (state, product) => {
  state.items = [product, ...state.items]
}
/**
 * 장바구니에 있는 상품의 상태 값을 갱신한다.
 * @param {*} state
 * @param {Object} product - 새로운 상품
 */
const UPDATE_PRODUCT_STATUS = (state, product) => {
  const cartItem = findItemFromCart(state, product.productId)
  if (cartItem) {
    for (let key in product) {
      if (key != 'productId' && cartItem.hasOwnProperty(key)) {
        cartItem[key] = product[key]
      }
    }
  }
}
/**
 * 모든 상품의 check 값을 갱신한다.
 * @param {*} state
 * @param {boolean} checked - 상품의 선택 여부
 */
const UPDATE_ALL_PRODUCT_CHECK_STATUS = (state, checked) => {
  state.items.forEach(el => {
    if (el.productStatus === 2) el.checked = checked
  })
}
/**
 * 장바구니에서 특정 상품을 제거한다.
 * @param {*} state
 * @param {Array} productIds - 상품 id목록
 */
const REMOVE_PRODUCT_OF_CART = (state, productIds) => {
  if (productIds.length) {
    // 선택된 제품 삭제 하기
    state.items = state.items.filter(function(el) {
      return this.indexOf(el.productId) < 0
    }, productIds)
  } else {
    // 전체 삭제하기
    state.items = []
  }
}
/**
 * 장바구니에서 선택된 상품들을 제거한다.
 * @param {*} state
 * @param {Array} products
 */
const REMOVE_SELECTED_PRODUCT_OF_CART = state => {
  state.items = state.items.filter(el => !el.checked)
}

export default {
  SET_PRODUCT_LIST_OF_CART,
  ADD_PRODUCT_TO_CART,
  REMOVE_PRODUCT_OF_CART,
  REMOVE_SELECTED_PRODUCT_OF_CART,
  UPDATE_ALL_PRODUCT_CHECK_STATUS,
  UPDATE_PRODUCT_STATUS
}
